import { Header } from '../components/homepage/Header';
import { HeroSection } from '../components/homepage/HeroSection';
import { TrustBar } from '../components/homepage/TrustBar';
import { BenefitsSection } from '../components/homepage/BenefitsSection';
import { ImpactSection } from '../components/homepage/ImpactSection';
import { FAQSection } from '../components/homepage/FAQSection';
import { FeaturesSection } from '../components/homepage/FeaturesSection';
import { CTASection } from '../components/homepage/CTASection';
import { Footer } from '../components/homepage/Footer';

export function HomePage() {
  return (
    <div className="min-h-screen bg-brand-5 font-urbanist">
      <Header />
      <main>
        <HeroSection />
        <TrustBar />
        <BenefitsSection />
        <ImpactSection />
        <FeaturesSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
